import React, { useEffect, useState } from "react";
import config from "../../config";
import client from "../../client";

export const PaymentButton = (props) => {
  const [cashfreeLoaded, setCashfreeLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;

    script.onload = () => {
      setCashfreeLoaded(true);
    };

    script.onerror = () => {
      console.error("Failed to load Cashfree SDK");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const payNow = (payload) => {
    if (!cashfreeLoaded || !window.Cashfree) {
      console.error("Cashfree SDK is not loaded");
      return;
    }

    client()
      .post(`${config.authAPI}/payment/cashfree`, payload)
      .then((res) => {
        console.log("Cashfree order:", res.data);

        if (!res.data.payment_session_id) {
          console.error("Unable to create payment");
          return;
        }

        const cashfree = window.Cashfree({
          mode: "sandbox",
        });

        cashfree.checkout({
          paymentSessionId: res.data.payment_session_id,
          redirectTarget: "_modal",
        }).then(() => {
            // Payment checkout callback
            console.log("Cashfree checkout completed");
            setCashfreeLoaded(false);
            getOrderDetails(payload);
          })
          .catch((error) => {
            console.error("Cashfree checkout error:", error);

            getOrderDetails(payload);
          });
      })
      .catch((error) => {
        console.error(
          "Payment Failed:",
          error.response ? error.response.data : error || error.message
        );
      });
  };

const getOrderDetails = (payload) => {
    client()
      .post(`${config.authAPI}/payment/cashfreeOrder`, {
        orderId: payload.order_id,
        isTestEnvironment: payload.isTestEnvironment
      })
      .then((orderDetailsResponse) => {
        orderDetailsResponse = orderDetailsResponse.data;

        console.log(
          "Cashfree order details:",
          orderDetailsResponse
        );

        if (props.onPaymentComplete) {
          props.onPaymentComplete(orderDetailsResponse);
        }
      })
      .catch((error) => {
        console.error(
          "Unable to fetch order details:",
          error.response ? error.response.data : error || error.message
        );
      });
  };

  return (
    <button
      type="button"
      disabled={!cashfreeLoaded}
      onClick={() => payNow(props.payload)}
    >
      {cashfreeLoaded ? "Pay" : "Loading..."}
    </button>
  );
};